<script>
import TariffsComponent from './Tariffs/component.vue';
import DatesComponent from './Dates/component.vue';
import DescriptionComponent from './Description/component.vue';
import ServicesComponent from './Services/component.vue';

export default {
  components: {
    TariffsComponent,
    DatesComponent,
    DescriptionComponent,
    ServicesComponent,
  },
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    linkString: '',
  }),
  methods: {
    copyLInk() {
      this.linkString = `magWidget.getTourById(${this.module.id})`;
      setTimeout(() => {
        try {
          this.$refs.cloneLink.focus();
          document.execCommand('copy');
          this.$core.notify.success('Скопировано!');
        } catch (err) {
          this.$core.notify.error(err);
        }
      }, 1000);
    },
    handlerSubmit(isClose) {
      const self = this;
      this.loading = true;
      this.module.submit()
        .then((data) => {
          if (data.IsError) {
            self.$notify.error(data.Message)
          } else {
            const id = data.Tour.Id;
            if (id !== 0) {
              if (isClose) {
                this.$emit('submit', this.module);
              } else {
                const path = `/admin/tour/${id}`
                if (self.$route.path !== path) {
                  self.$router.push(path);
                } else {
                  self.$router.go();
                }
              }
            } else {
              self.$notify.error('Ошибка сохранения!');
            }
          }
        })
        .catch((error) => {
          self.$notify.error(error)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlerClose() {
      this.$emit('close');
    },
  },
};
</script>
<template>
  <div>
    <input v-on:focus="$event.target.select()" ref="cloneLink" readonly  v-model="linkString"  style='height:0px; opacity:0'/>
    <RowSpan>
      <ColSpan span="4">
        <FBodyCard
          label="Основная информация"
          :module="module.main"
        />
      </ColSpan>
      <ColSpan span="4">
        <FBodyCard
          label="Направление"
          :module="module.direction"
        />
      </ColSpan>
      <ColSpan span="4">
        <FBodyCard
          label="О туре"
          :module="module.tourData"
        />
      </ColSpan>
    </RowSpan>
    <TariffsComponent
      :module="module.tariffs"
    />
    <ServicesComponent
      :module="module.services"
    />
    <DatesComponent
      :module="module.dates"
      :isDefaultTariff="module.dontUseTariffs"
    />
    <DescriptionComponent
      :module="module.description"
    />
    <Card
      fixed-bottom
      align-right
    >
      <BtnDefault
        @click="handlerClose"
      >
        Закрыть
      </BtnDefault>
      <BtnPrimaryBlue
        v-if="module.id"
        @click="copyLInk()"
      >
       Скопировать ссылку на тур
      </BtnPrimaryBlue>
      <BtnPrimary
        @click="handlerSubmit(false)"
      >
        {{module.id ? 'Сохранить тур' : 'Создать тур'}}
      </BtnPrimary>
      <BtnPrimary
        @click="handlerSubmit(true)"
      >
        Сохранить и закрыть
      </BtnPrimary>
    </Card>

    <Load v-if="loading" fixed></Load>
  </div>
</template>
<style lang="scss">
  .line-form {
    display: flex;
    padding: 4px 0;

    &__item {
      margin: 0 2px;
      position: relative;
      flex: 1;
    }

    &__btn {
      margin: 0 2px;
      position: relative;
      flex-shrink: 0;
      padding: 15px 0 0 0;

      i {
        padding: 0 4px;
      }
    }

    &__label {
      padding: 0 0 0 2px;
      font-size: 13px;
      color: #777;
    }

    &__input {
      background: #f5f5f5;
      padding: 4px 2px;
      font-size: 16px;
      border-bottom: #999 1px solid;
      color: #333;
    }
  }
</style>
